import { render } from "./TemplateMfittSelectPaymentMethod.vue?vue&type=template&id=4fd26f2b"
import script from "./TemplateMfittSelectPaymentMethod.vue?vue&type=script&lang=js"
export * from "./TemplateMfittSelectPaymentMethod.vue?vue&type=script&lang=js"

import "./TemplateMfittSelectPaymentMethod.vue?vue&type=style&index=0&id=4fd26f2b&socped=true&lang=css"
script.render = render

export default script